import axios from "axios";
import { getHeaders, getURl } from "./core";

let url = `${getURl()}/pdd/v1`;


export function getPerformanceModules(type) {
   const result = axios({
      method: "GET",
      headers: getHeaders(),
      url: `${url}/performance_modules?type=${type}`,
   });
   return new Promise((resolve, reject) => {
      result
         .then((response) => resolve(response.data))
         .catch((error) => reject(error));
   });
}

export function getSelfEvaluations({ offset = 0, limit = 15, search = "", year = 0 }) {
   const result = axios({
      method: "GET",
      headers: getHeaders(),
      url: `${url}/lists?offset=${offset}&limit=${limit}&search=${search}&year=${year}`,
   });
   return new Promise((resolve, reject) => {
      result
         .then((response) => resolve(response.data))
         .catch((error) => reject(error));
   });
}

export function getPDDById(id, type) {
   const result = axios({
      method: "GET",
      headers: getHeaders(),
      url: `${url}/detail/${id}?type=${type}`,
   });
   return new Promise((resolve, reject) => {
      result
         .then((response) => resolve(response.data))
         .catch((error) => reject(error));
   });
}

export function createPDD(data) {
   return axios({
      method: "POST",
      headers: getHeaders(),
      url: `${url}/create`,
      data
   })
}

export function updatePDDById(id, data) {
   return axios({
      method: "PUT",
      headers: getHeaders(),
      url: `${url}/update/${id}`,
      data
   })
}

export function getQuarterlyReviews() {
   const result = axios({
      method: "GET",
      headers: getHeaders(),
      url: `${url}/quarterly_reviews`,
   });
   return new Promise((resolve, reject) => {
      result
         .then((response) => resolve(response.data))
         .catch((error) => reject(error));
   });
}

export function getQuarterlyReviewById(id) {
   const result = axios({
      method: "GET",
      headers: getHeaders(),
      url: `${url}/quarterly_reviews/${id}`
   });
   return new Promise((resolve, reject) => {
      result
         .then((response) => resolve(response.data))
         .catch((error) => reject(error));
   });
}

export function createQuarterlyReview(data) {
   return axios({
      method: "POST",
      headers: getHeaders(),
      url: `${url}/quarterly_reviews`,
      data
   })
}

export function updateQuarterlyReviewById(id, data) {
   return axios({
      method: "PUT",
      headers: getHeaders(),
      url: `${url}/quarterly_reviews/${id}`,
      data
   })
}

export function submitQuarterlyReview(id) {
   return axios({
      method: "PUT",
      headers: getHeaders(),
      url: `${url}/submit_quarterly_reviews/${id}`
   })
}

export function submitObjectives(id, data) {
   return axios({
      method: "PUT",
      headers: getHeaders(),
      url: `${url}/submit_objective/${id}`,
      data
   })
}

export function approveObjectives(id) {
   return axios({
      method: "PUT",
      headers: getHeaders(),
      url: `${url}/approve_objective/${id}`
   })
}

export function markAsQuarterlyReviewed(id, status) {
   return axios({
      method: "PUT",
      headers: getHeaders(),
      url: `${url}/mark_as_quarter_reviwed/${id}`,
      data: {
         status
      }
   })
}

export function submitSelfEvaluation(id, data) {
   return axios({
      method: "PUT",
      headers: getHeaders(),
      url: `${url}/submit/${id}`,
      data,
   })
}

export function approveEvaluation(id, data) {
   return axios({
      method: "PUT",
      headers: getHeaders(),
      url: `${url}/approve/${id}`,
      data
   })
}

export function deletePDDById(id) {
   return axios({
      method: "DELETE",
      headers: getHeaders(),
      url: `${url}/archive/${id}`,
   });
}